import type { UUID } from '@/utils/uuid';

export const memberQueryKeys = {
  list: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['members', tenantId, limit ?? null, filter ?? null] as const,
  listByTenant: (tenantId?: UUID) => ['members', tenantId] as const,
  detail: (tenantId?: UUID, userId?: UUID) =>
    ['member', tenantId, userId] as const,
  invitationList: (tenantId?: UUID, limit?: number, filter?: string) =>
    ['invitations', tenantId, limit ?? null, filter ?? null] as const,
  invitationListByTenant: (tenantId?: UUID) =>
    ['invitations', tenantId] as const,
};

export const memberMutationKeys = {
  inviteMember: (tenantId?: UUID) => ['inviteMember', tenantId] as const,
  revokeInvitation: (tenantId?: UUID) =>
    ['revokeInvitation', tenantId] as const,
  removeMember: (tenantId?: UUID) => ['removeMember', tenantId] as const,
};
